import CommonPage from "../../CommonPage";
import { Grid, Skeleton, styled } from "@mui/material";
import FluxoDefaultConnected from "./default/FluxoDefault.connected";
import ClienteHeaderConnected from "../../../components/presentation/ClienteHeader.connected";

const SkeletonCard = styled(Skeleton)`
  width: 100%;
  height: 239px;
  border-radius: 1rem;
`;

const PreenchimentoClientePage = ({ loading, cliente }) => {
  const isLoading = !!loading || !cliente;

  return (
    <CommonPage selected={"clientes"}>
      {isLoading && (
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <SkeletonCard variant={"rectangular"} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <SkeletonCard variant={"rectangular"} />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <SkeletonCard variant={"rectangular"} />
          </Grid>
        </Grid>
      )}
      {!isLoading && (
        <Grid container spacing={3}>
          <ClienteHeaderConnected cliente={cliente}/>
          <FluxoDefaultConnected />;
        </Grid>
      )}
    </CommonPage>
  );
};

export default PreenchimentoClientePage;
